import * as actions from './actions'
import reducer from './reducer'
import * as TypeAction from './actionTypes'



const config = {

    reducerConfig: { nome: "DinamicCustomFormsReducer", reducer: reducer }
}

export default config


export { actions, reducer,  TypeAction }




// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/index.js